export default __webpack_public_path__ + "static/lozenge-dropdown-trigger-dont-81aa4da03b4b8a77bdb1974d6a165dff59013825ec0a1b246ec9222a89ce108e.png";